import styled from 'styled-components';
import { StyledDiv } from '../../Theme/CommonStyled';

export const StyledCodeContainer = styled.div`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  height: 78px;
  border-radius: ${({ theme }): string => theme.radii.xxl};
  display: flex;
  align-items: center;
  padding: 14px;
  direction: rtl;
  margin-bottom: 20px;
  position: relative;
`;

export const StyledCode = styled(StyledDiv)`
  transition: 0.3s;
  ${({ codeIsCopied }): string =>
    codeIsCopied ? `transform: scale(0);` : `transform: scale(1);`};
`;

export const StyledCreditItem = styled.div`
  background-color: ${({ theme }): string => theme.colors.mainBackground};\
  padding: 14px;
  padding-right: 0;
  width: 100%;
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  cursor: pointer;
  
  :not(:last-of-type){
    margin-bottom: 10px;
  }
`;

export const StyledItemIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 2;
  border-left: ${({ theme }): string => theme.borders[0]};
  border-color: ${({ theme }): string => theme.colors.border};
  margin-left: 8px;
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 4;

  div {
    :not(:last-of-type) {
      margin-bottom: 4px;
    }
  }
`;
